module.exports = __webpack_public_path__ + "static/media/44handle.cceac0e6.png";